<section [id]="id" class="welcome-overlay bgc-glass" [ngStyle]="overlayStyles">
  <div id="avatar" class="avatar-container">
    <app-avatar
      [avatarUri]="user?.avatarUri"
      [userInitials]="user?.userInitials"
      [viewportSize]="viewportSize"
      title="Welcome Avatar profile image"></app-avatar>
  </div>
  <div class="welcome-message">
    <h1 class="welcome-greeting brand-primary-azure larger-font">{{ getUserGreeting() }}</h1>
    <p id="welcome-greeting">{{ message }}</p>
  </div>
</section>
